import { Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import { AppDispatch, RootState } from "../../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { getDateRange, scroll } from "../../../../components/utils/utils";
import "moment/locale/ar";
import ProgramListRequest from "./ProgramListRequest";
import {
  toGetProgramRequests,
  toGetProgramsCategories,
} from "../../../../apis/actions/programs.actions";
import CustomConfigProvider from "../../ProfileHeader";
const ProgramListRequestsOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { program, loading, categories, TotalProgramsRequest } = useSelector(
    (state: RootState) => state?.programs
  );
  useEffect(() => {
    dispatch(toGetProgramsCategories());
  }, [dispatch]);

  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  useEffect(() => {
    setCurrentPage(1);
  }, [state, selectedFilter]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      toGetProgramRequests({
        limit: itemPerPage,
        page: currentPage,
        program_id: selectedFilter,
        date_from: date_from,
        date_to: date_to,
      })
    );
  }, [dispatch, currentPage, selectedFilter, state]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.value);
      setCurrentPage(1);
    } else {
      setSelectedFilter(null);
    }
  };
  return (
    <>
      <CustomConfigProvider
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
        title="الترشحات للبرامج"
      >
        <Selects
          options={categories}
          selectPlaceholder="صنف البرنامج"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      // eslint-disable-next-line eqeqeq
      ) : program?.length === 0 && !selectedFilter && state.year == "" ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد ترشحات
        </p>
      ) : program?.length === 0 && (selectedFilter || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد ترشحات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <ProgramListRequest requests={program} />
          </Row>
          <div className="takaful--pagination-container">
            {program &&
              Math.ceil(TotalProgramsRequest) * itemPerPage > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalProgramsRequest) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
    </>
  );
};

export default ProgramListRequestsOverview;
